<template>
  <div v-if="pgLoading" class="loadingLogo">
    <img src="/assets/img/logo/charity-logo.png" alt="children's heart logo" />
  </div>
  <div v-else class="">
    <section class="cases-area pt-30 pb-30">
      <div class="container">
        <div v-if="pgLoading" class="row justify-content-center">
          <div class="col-lg-4 col-md-6" v-for="(row, index) in 3" :key="index">
            <div class="single-causes">
              <div class="webkit-animation webkit-100-500"></div>
              <div class="causes-content webkit-animation webkit-100-235"></div>
            </div>
          </div>
        </div>

        <div v-else class="row">
          <div class="col-xl-12">
            <div class="section-title text-center mb-3 pl-50 pr-50 wow fadeInUp2 animated" data-wow-delay=".1s"
              :style="locale == 'en' ? 'text-align: left !important' : ''">
              <!-- <h6>
                <span>
                  <i class="fas fa-tasks"></i>
                </span>
                {{ $t("app.our_projects") }}
              </h6> -->
              <h2 v-if="info">{{ info.title }}</h2>
            </div>
          </div>
        </div>


        <div class="project-cards-grid">
          <ProjectCard v-for="(row, idx) in rows" :key="idx" :row="row" />
        </div>

        <div class="home-main-carousel row d-none" v-if="!pgLoading && items" :rtl="$i18n.locale == 'ar' ? true : false"
          :items="3" :loop="true" :margin="20" :nav="false" :center="true" :responsive="{
            0: { items: 1 },
            767: { items: 1 },
            1000: { items: 3 },
          }" :dots="false">
          <!-- Project Item -->
          <div class="item col-xl-4 col-md-6" v-for="(row, idx) in rows" :key="idx">
            <div class="cases grey-bg2 mb-30 wow fadeInUp2 animated" style="border-radius: 15px;" data-wow-delay=".3s">
              <div class="cases__box pos-rel card-image" style="border-radius: 15px; overflow: hidden;">
                <div class="icons position-absolute top-0 right-0">
                  <!-- <ul>
                    <li>
                      <a href="">
                        <i class="fab fa-facebook"></i>
                      </a>
                    </li>
                  </ul> -->
                </div>
                <div class="cases__box--img">
                  <router-link :to="{
                    name: 'show-projects',
                    params: { slug: row.slug, id: row.id },
                  }">
                    <img v-if="row.image" :src="row.image
                      ? row.image.url
                      : '/assets/img/logo/min-logo.png'
                      " :alt="row.title" class="img-box-500" @error="handleImageError" />
                    <img v-else :src="placeholder" alt="Placeholder" loading="lazy" />
                  </router-link>
                </div>
                <ul class="cases__tag white-bg">
                  <li>
                    <div class="cases--author d-flex align-items-center">
                      <!--   <img src="/assets/img/flags/egypt-flag.png" alt="" /> -->
                      <flag v-if="row.country" :iso="row.country.ccode" style="font-size: 35px; border-radius: 50%" />
                      <div>
                        <h4 class="semi-02-title ml-15" style="font-size: 17px">
                          {{ row.country ? row.country.name : "" }}
                        </h4>
                        <span v-if="row.main_category">{{ shortlen(row.main_category.name, 12) }}</span>
                      </div>
                    </div>
                  </li>
                  <li>
                    <a class="theme_btn theme_btn_bg d-btn case-card-target" href="#">
                      <div>{{ $t("app.target") }}</div>
                      <div>{{ row.target }} {{ $t("app.dinar") }}</div>
                    </a>
                  </li>
                </ul>
              </div>
              <div class="cases__content">
                <router-link :to="{
                  name: 'show-projects',
                  params: { slug: row.slug, id: row.id },
                }">
                  <h5 style="height: 2em" v-if="locale == 'en'">
                    {{ shortlen(row.title, 60) }}
                  </h5>
                  <h5 style="height: 2em; text-align: right" v-if="locale == 'ar'">
                    {{ shortlen(row.title, 60) }}
                  </h5>
                </router-link>
                <p class="project-desc">
                  <!--     هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم
                                    توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل
                                    هذا النص أو العديد من النصوص الأخرى إضافة إلى زيادة عدد
                                    الحروف التى يولدها التطبيق. إذا كنت تحتاج إلى عدد أكبر من
                                    الفقرات
                                -->
                </p>

                <div class="cases-progress">
                  <!-- <p class="funding">{{$t('app.collect')}} <span>2500 {{$t('app.dinar')}}</span></p> -->
                  <div class="progress ">
                    <div class="progress-bar wow fadeInLeft animated" data-wow-delay="0.3s" role="progressbar"
                      :style="{ width: row.percentage + '%' }" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                      <h5 class="text-start">{{ row.percentage }}%</h5>
                    </div>
                  </div>
                  <div class="d-flex justify-content-between mt-3 border p-2 rounded-2">
                    <div class="text-center">
                      <p>{{ $t('app.paidMoney') }}</p>
                      <span>{{ row.paid }} {{ $t('app.kw') }}</span>
                    </div>
                    <div style="width: 1px; height: 50px; margin-top: 2px; background-color: #ccc; "></div>
                    <div class="text-center">
                      <p>{{ $t('app.remainMoney') }}</p>
                      <span>{{ row.remain }} {{ $t('app.kw') }}</span>
                    </div>
                  </div>

                  <div class="row justify-content-center mt-15 mb-0">
                    <div class="teams__thumb--social"
                      style="display: contents; background-color: transparent !important">
                      <a :href="'https://facebook.com/sharer/sharer.php?u=' +
                        current_url + '/' + row.slug
                        " target="_blank">
                        <i class="fab fa-facebook-f"></i>
                        <i class="fab fa-facebook-f"></i>
                      </a>
                      <a :href="'https://twitter.com/share?url=' + current_url + '/' + row.slug" target="_blank">
                        <i class="fab fa-twitter"></i>
                        <i class="fab fa-twitter"></i>
                      </a>
                      <!-- <a
                  :href="
                    'https://pinterest.com/pin/create/bookmarklet/?&amp;url=' +
                    current_url+ '/' + row.slug
                  "
                  target="_blank"
                >
                  <i class="fab fa-pinterest"></i>
                  <i class="fab fa-pinterest"></i>
                </a> -->
                      <a :href="'https://www.linkedin.com/shareArticle?url=' +
                        current_url + '/' + row.slug
                        " target="_blank">
                        <i class="fab fa-linkedin"></i>
                        <i class="fab fa-linkedin"></i>
                      </a>
                      <a href="javascript:;" @click="addToShares(row.id)">
                        <i class="far fa-share"></i>
                        <i class="far fa-share"></i>
                      </a>
                    </div>
                    <!-- <div class="article-tags">
                  <span>
                      <i class="far fa-share"></i>
                  </span>
                  <a href="javascript:;" @click.prevent="copyUrl()">
                      {{ $t('project.share') }}
                  </a>
              </div> -->
                  </div>
                  <div class="case-btns mt-4 d-flex justify-content-center">
                    <a :href="whatsAppNo + row.title" target="_blank"
                      class="theme_btn theme_btn-whatsapp theme_btn_bg">{{ $t("app.contact") }}
                      <span :style="[locale == 'en' ? { left: 'auto' } : {}]"><i class="fab fa-whatsapp"></i></span>
                    </a>
                    <!-- <router-link
                      :to="{
                        name: 'show-projects',
                        params: { slug: row.slug, id: row.id },
                      }"
                      class="theme_btn theme_btn_bg"
                    >
                      {{ $t("app.donate") }}
                      <span :style="[locale == 'en' ? { left: 'auto' } : {}]"
                        ><i class="fas fa-angle-double-left"></i
                      ></span>
                    </router-link> -->
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>


<script>
// import carousel from "v-owl-carousel";

export default {
  name: "LatestProjects",
  components: {
    // carousel,
    ProjectCard: () => import("@/components/ProjectCard.vue"),
  },
  data() {
    return {
      //

      items: [],

      refs: "projects",
      auth: {
        access_token: "",
      },
      locale: "ar",
      pgLoading: false,
      info: null,
      infoData: null,
      rows: [],
      placeholder: "/assets/img/logo/min-logo.png",
      imageLoaded: false,
      whatsAppNo: window.whatsAppNo,
      current_url: window.location.origin + this.$route.path + 'projects',
    };
  },
  mounted() {
  },
  created() {
    //

    if (localStorage.getItem("access_token")) {
      this.auth.access_token = localStorage.getItem("access_token");
    }
    if (localStorage.getItem("locale")) {
      this.locale = localStorage.getItem("locale");
    }

    this.fetchData();
  },
  methods: {
    handleImageError(event) {
      event.target.src = "/assets/img/logo/min-logo.png";
    },
    onImageLoad() {
      console.log("Image loaded successfully");
      this.imageLoaded = true;
    },
    onImageError() {
      console.error("Error loading image");
    },

    //
    fetchData() {
      this.pgLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
      };
      const options = {
        url: window.baseURL + "/mongezProjects",
        method: "GET",
        data: {},
        params: {
          locale: this.locale,
          status: "active",
          paginate: 24,
          order_by: "sort",
          order: "DESC",
          completeOrNew: 1,
        },
      };
      this.axios(options)
        .then((res) => {
          this.pgLoading = false;
          this.rows = res.data.rows;
          console.log(res);

          this.info = res.data.info;
          this.infoData = res.data.info;
        })
        .catch(() => {
          //
        })
        .finally(() => { });
    },

    addToShares(proid) {
      // this.$axios.defaults.headers.common = {
      //   'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
      //   'Authorization': `Bearer ${this.auth.access_token}`,
      // };
      const options = {
        url: window.baseURL + "/shares",
        method: "POST",
        headers: {
          'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
          'Authorization': `Bearer ${this.auth.access_token}`,
        },
        data: {
          decrypt_model_id: proid,
          model: "projects",
          user_id: true,
          status: true,
        },
        params: {},
      };
      console.log(`Bearer ` + this.auth.access_token);
      console.log(options);
      this.$axios(options)
        .then(() => {
          iziToast.success({
            icon: "ti-check",
            title: "",
            message: this.$t("app.share_msg"),
          });
        })
        .catch((err) => {
          if (err.response && err.response.status == 401) {
            console.log(err.response.message);
            this.removeLocalStorage();
            this.$router.push({ name: "login" });
          } else {
            iziToast.warning({
              icon: "ti-alert",
              title: "",
              message: this.$t("app.share_msg_failed"),
            });
          }
        })
        .finally(() => { });
    },

    shortlen(string, len) {
      let dots = "";
      if (string.length > len) {
        dots = "...";
      }
      return (
        string.substring(0, len + string.substring(len - 1).indexOf(" ")) + dots
      );
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.cases-area {
  padding-block: 60px;
}

.cases-area .section-title {
  margin-bottom: 32px !important;
  text-align: center !important;
}

@media (min-width: 1200px) {
  .cases-area > .container {
    max-width: 1320px;
  }
}

.card-image {
  position: relative;
  color: #fff;
}

.card-image .icons {
  position: fixed;
  top: 0px;
  right: 0px;
  background-color: #eee;
}

.rtl .cases-progress .progress .progress-bar h5 {
  position: absolute;
  right: 88%;
  top: -22px;
}


@media (max-width: 991.98px) {
  .cases-area {
    padding-block: 48px;
  }

  .cases-area .section-title {
    margin-bottom: 28px !important;
  }

}

@media (max-width: 480px) {
  .cases-area {
    padding-block: 40px;
  }

  .cases-area .section-title {
    margin-bottom: 24px !important;
    padding-inline: 0;
  }

}
</style>
